import { SELECTIONS_CONTAINER_ELEMENT_ID } from '../constants';

// The Container MUST be 'auto'.
// This allows the children to sort individually against the cell content.
// If you set this to 0, the Cell Content (11) will cover your Focus Box.
const HIGHLIGHTS_CONTAINER_Z_INDEX = 'auto';

/**
 * Creates the container that holds all selection overlays (focus box,
 * range highlights, etc.). Lives inside the scrollableContainer so it
 * scrolls with the grid content.
 *
 * pointer-events: none so the overlay doesn't block interactions with cells.
 */
export function createHighlightsContainerElement() {
  const overlayContainer = document.createElement('div');

  overlayContainer.id = SELECTIONS_CONTAINER_ELEMENT_ID;
  overlayContainer.style.position = 'absolute';
  overlayContainer.style.top = '0';
  overlayContainer.style.left = '0';
  overlayContainer.style.pointerEvents = 'none';
  overlayContainer.style.zIndex = `${HIGHLIGHTS_CONTAINER_Z_INDEX}`;

  return overlayContainer;
}
